import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../../components/tables/ReportsTable';

const CommissionReports = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const serviceTypes = ['Recharge', 'Bill Payment', 'DMT', 'AEPS', 'BBPS', 'Payout'];
    const statuses = ['Success', 'Pending', 'Failed'];
    
    return Array.from({ length: count }, (_, i) => {
      const amount = (Math.random() * 10000 + 1000);
      const serviceCharges = (amount * 0.02).toFixed(2);
      const baseRate = (Math.random() * 3 + 0.5).toFixed(2);
      const retailerCommission = (amount * parseFloat(baseRate) / 100).toFixed(2);
      const retailerTDS = (parseFloat(retailerCommission) * 0.05).toFixed(2);
      const distributorCommission = (amount * 0.015).toFixed(2);
      const masterDistCommission = (amount * 0.01).toFixed(2);
      const netCom = (parseFloat(retailerCommission) - parseFloat(retailerTDS)).toFixed(2);
      
      return {
        id: `TXN${String(i + 1).padStart(8, '0')}`,
        date: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
          .toISOString().split('T')[0],
        mobile: `${Math.floor(Math.random() * 9000000000) + 1000000000}`,
        status: statuses[Math.floor(Math.random() * statuses.length)],
        amount: amount.toFixed(2),
        serviceCharges: serviceCharges,
        baseRate: baseRate + '%',
        retailerCommission: retailerCommission,
        retailerTDS: retailerTDS,
        distributorCommission: distributorCommission,
        masterDistCommission: masterDistCommission,
        netCom: netCom,
        service: serviceTypes[Math.floor(Math.random() * serviceTypes.length)],
        retailer_shop: `Shop ${Math.floor(Math.random() * 500) + 1}`,
        retailer_name: `Retailer ${Math.floor(Math.random() * 500) + 1}`,
        retailer_mobile: `${Math.floor(Math.random() * 9000000000) + 1000000000}`,
        retailer_pan: `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10000).toString().padStart(4, '0')}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`
      };
    });
  };

  const [data] = useState(generateSampleData(60));

  // Column definitions
  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'date', label: 'Date' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'status', label: 'Status' },
    { key: 'amount', label: 'Amount' },
    { key: 'serviceCharges', label: 'Service Charges' },
    { key: 'baseRate', label: 'Base Rate' },
    { key: 'retailerCommission', label: 'Retailer Commission' },
    { key: 'retailerTDS', label: 'Retailer TDS' },
    { key: 'distributorCommission', label: 'Distributor Commission' },
    { key: 'masterDistCommission', label: 'Master Dist Commission' },
    { key: 'netCom', label: 'Net Com' },
    { key: 'service', label: 'Service' },
    { key: 'retailer_shop', label: 'Retailer Shop' },
    { key: 'retailer_name', label: 'Retailer Name' },
    { key: 'retailer_mobile', label: 'Retailer Mobile' },
    { key: 'retailer_pan', label: 'Retailer PAN' }
  ];

  return (
    <Container fluid className="">
      <ReportsTable
        data={data}
        reportType="Commission_Reports"
        columns={columns}
        title="Commission Reports"
      />
    </Container>
  );
};

export default CommissionReports;

